import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { LineReveal, EASE } from "@/components/site/Reveal";

export const PageHero = ({ eyebrow, lines, intro, image, testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  return (
    <section ref={ref} data-testid={testId} className="relative overflow-hidden bg-[var(--ink)] pt-36 lg:pt-44 pb-16 lg:pb-24">
      <div className="hero-grid absolute inset-0 opacity-50" aria-hidden />
      <div className="relative mx-auto max-w-[1440px] px-5 lg:px-10 grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="eyebrow">{eyebrow}</motion.p>
          <LineReveal as="h1" lines={lines} delay={0.1} className="mt-6 font-display font-black uppercase leading-[0.86] text-white text-6xl sm:text-7xl lg:text-8xl xl:text-[8.5rem]" />
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.9, ease: EASE }} className="mt-8 max-w-xl text-base sm:text-lg text-slate-300 leading-relaxed">
            {intro}
          </motion.p>
        </div>
        {image && (
          <motion.div initial={{ clipPath: "inset(100% 0 0 0)" }} animate={{ clipPath: "inset(0% 0 0 0)" }} transition={{ duration: 1.3, delay: 0.25, ease: EASE }} className="lg:col-span-5 relative aspect-[4/3] lg:aspect-[4/5] overflow-hidden clip-diagonal">
            <motion.img style={{ y, scale: 1.2 }} src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)]/70 to-transparent" />
          </motion.div>
        )}
      </div>
    </section>
  );
};
